
<template>
    <div class="article-header">
        <tag :text="category" class="bg-primary text-white" />
        <p>
            por <span>UGT-SP</span>, {{ date }}
        </p>
    </div>
</template>

<script>
import Tag from './tag';
export default {
    name: 'article-header',

    components: {
        Tag,
    },

    props: {
        category: String,
        date: String,
    },

    methods: {

    }
}
</script>

<style scoped lang="scss">
.article-header {
    @apply flex flex-row justify-between items-center py-2 px-0;
    p{
        @apply text-base pl-5;
        span {
            @apply text-tertiary text-base;
        }
    }
}
</style>
